import {
    Component, Mixins, Watch,
} from 'vue-property-decorator';
import CoreMixin from '@nodes/mixins/Core';
import { digits, separated } from '@nodes/helpers/number';
import { YPanel, YInput, YImage } from '@components/index';
import isEqual from 'lodash.isequal';
import HybridMixin from '@rogues/shared/mixins/hybrid';
import Props from './props';

@Component({
    components: {
        YPanel,
        YInput,
        YImage,
    },
})

/**
 * @name ProfileChargeWallet
 */
export default class ProfileChargeWallet extends Mixins(CoreMixin, HybridMixin, Props) {
    digits = digits;
    separated = separated;

    chargeAmount: string|number = '0';
    gates = null;
    selectedGate: string|boolean = false;
    quickChargeButtons = ['10000', '20000', '50000', '100000'];

    /**
     * Check if form is filled
     * 
     * @returns {boolean}
     */
    get formIsFilled(): boolean {
        return !!this.chargeAmount && this.chargeAmount !== '0' && !!this.selectedGate;
    }

    /**
     * @inheritdoc
     */
    created() {
        // Show toast message after payment
        if (this.$route.query?.success === '1') {
            this.$toast.success(this.$t('dashboard.wallet.charge.messages.success'));
            this.$router.replace({ query: null });
        } else if (this.$route.query?.error) {
            this.$toast.error(this.$t('dashboard.wallet.charge.messages.error'));
            this.$router.replace({ query: null });
        }
    }

    /**
     * Fetch Gates if wallets exist
     *
     * @param {object} val
     * @param {object} oldVal
     */
    @Watch('wallets', { immediate: true, deep: true })
    onWalletChanged(val: object, oldVal: object) {
        if (val && !isEqual(val, oldVal)) {
            this.fetchGates();
        }
    }

    /**
     * Highlight Quick Charge Item
     * 
     * @param {string | number} amount
     * @returns {boolean}
     */
    highlightQuickItem(amount: string | number): boolean {
        return this.chargeAmount !== amount;
    }

    /**
     * Fetch Online Gates
     * 
     * @returns {*}
     */
    fetchGates(): any {
        this.$wait.start('fetch-online-gates');
        const params = {
            id: this.getValue('wallets')[0].id,
        };
        return this.$services[this.fetchGatesServices.name][this.fetchGatesServices.api](params).then((response) => {
            this.gates = response.data.results;
        }).catch((error: object) => {
            this.handleError(error);
        }).finally(() => {
            this.$wait.end('fetch-online-gates');
        });
    }

    /**
     * Charge Wallet
     * 
     * @returns {*}
     */
    chargeWallet(): any {
        this.$wait.start('charge-wallet');
        const callbackRoute = this.$router.resolve({ name: this.$route.name }).href;
        const baseUrl = window.location.origin;
        const params = {
            id          : this.getValue('wallets')[0].id,
            path_id     : this.selectedGate,
            amount      : this.chargeAmount,
            callback_url: baseUrl + callbackRoute,
        };
        return this.$services[this.chargeWalletServices.name][this.chargeWalletServices.api](params).then((response) => {
            window.location.href = response.data.results.url;
        }).catch((error: object) => {
            this.handleError(error);
        }).finally(() => {
            this.$wait.end('charge-wallet');
        });
    }
}
